import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConfigService, UtilsMisc, } from '@pit/core';

@Injectable()
export class HttpInterceptorVersion implements HttpInterceptor {

    constructor(private configService: ConfigService) {
    }

    public intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        if (UtilsMisc.isNullOrUndefined(this.configService.configData.version) === false) {
            const req = request.clone({
                headers: request.headers.set('X-Api-Version', this.configService.configData.version)
            });
            return next.handle(req);
        } else {
            return next.handle(request);
        }
    }

}
